import { CircularProgress } from 'material-ui';
import Fade from 'material-ui/transitions/Fade';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Field, reduxForm, Form } from 'redux-form';
import Button from 'material-ui/Button';
import Paper from 'material-ui/Paper';

import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Card, { CardContent } from 'material-ui/Card';

import { FormControlLabel } from 'material-ui/Form';

import Typography from 'material-ui/Typography';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import Radio from 'material-ui/Radio';
import getReportTypes from '../actions/getReportTypes';
import searchByAttribute from '../actions/searchByAttribute';
import getCustomers from '../actions/getCustomers';
import getStateCountry from '../actions/getStateCountry';
import getCustomerGroups from '../actions/getCustomerGroups';
import search from '../actions/search';

import Layout from '../components/Layout';
import { ProductMapReversed } from '../helpers/ProductMap';
import validationHelper from '../helpers/ValidationHelper';
import renderRadioGroup from '../helpers/RenderRadioGroup';

import { clearRoutes } from '../actions/getRoutes';
import AutoComplete from '../helpers/AutoComplete';

const styles = theme => ({
  card: {
    display: 'flex',
    boxShadow: 'none',
    justifyContent: 'center'
  },
  content: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%'
  },
  paperStyle: {
    width: '40%',
    height: '70%',
    display: 'inline-block',
    margin: 20,
    marginTop: '13vh'
  },
  buttonStyle: {
    marginTop: 10,
    marginBottom: 15
  },
  headerStyle: {
    position: 'relative',
    width: '100%',
    height: '60px',
    background: '#FFFFFF',
    boxShadow: '0px 4px 6px -2px rgba(0,0,0,0.1)',
    borderBottom: '1px solid #e0e0e0',
  },
  headerTitleStyle: {
    flexDirection: 'column',
    margin: '2%',
    fontSize: '24px',
    fontFamily: 'Roboto'
  },
  productList: {
    display: 'flex',
    flexDirection: 'column !important',
    justifyContent: 'center',
    textAlign: 'center',
    fontSize: '18px',
    marginTop: '25px',
    paddingLeft: '10px',
    paddingRight: '10px'
  }
});

const validate = (values) => {
  return validationHelper.validateRequired(['selectedProduct'], values);
};

class ProductSelector extends Component {
  defaultProducts = ['AutoCheck Insurance', 'AutoCheck Auctions', 'VIN Cross Check'];
  state = {
    fetching: true,
    availableProducts: [],
    currentProduct: ""
  };
  
  componentDidMount() {
    const locationId = localStorage.getItem('locationId');
  
    if (locationId) {
      let customerId = localStorage.getItem('customerId');
      
      if (this.props.data && this.props.data.locations) {
        const location = this.props.data.locations && this.props.data.locations.find(l => l.locationId === locationId);
        customerId = location.customerId;
      }
      
      this.props.actions.getAvailableProducts(locationId, customerId, this.props.data.config, this);
    } else {
      this.setState({ availableProducts: this.defaultProducts });
    }
  }

  handleProductChange = (value) => {
    sessionStorage.setItem('product', value);
    this.currentProduct = value;
    this.setState({currentProduct: value });

  };
  
  handleSave = (event) => {
    const { config } = this.props.data;
    // sessionStorage.setItem('product', event.selectedProduct);
    
    this.props.actions.getLocationData(config);
    this.props.actions.getUsers(config);
    this.props.actions.getCustomers(config);
    this.props.actions.getCustomerGroups(config);
    this.props.actions.getPersonLocations(config);
    this.props.actions.getReportTypes(config);
    this.props.actions.getStateCountry(config);

    this.props.actions.clearRoutes();
    this.props.history.push('/');
  };
  
  renderLoadingAnimation = () => {
    const { fetching } = this.state;
    
    return (
        <Fade
            in={fetching}
            style={{
              transitionDelay: fetching ? '800ms' : '0ms'
            }}
            unmountOnExit
        >
          <CircularProgress style={{ marginTop: '10%' }} />
        </Fade>
    );
  };
  
  renderProductForm = () => {
    const { availableProducts } = this.state;
    const { classes, handleSubmit } = this.props;

    let suggestions = [];
    if (availableProducts && Array.isArray(availableProducts)) {
      suggestions = availableProducts.map(product => ({
        value: product,
        label: product
      }));
    }
    let selectedProduct = this.state.currentProduct;
    if (availableProducts.length === 1) {
      selectedProduct = this.state.availableProducts[0];
      sessionStorage.setItem('product', selectedProduct);
      this.handleSave();
    }
    
    return (
        <Paper className={classes.paperStyle}>
          <AppBar position="static" className={classes.headerStyle}>
            <Toolbar className={classes.headerTitleStyle}>
              <Typography variant="title">
                Change Product
              </Typography>
            </Toolbar>
          </AppBar>
          <Form style={{width: '100%'}} onSubmit={handleSubmit(this.handleSave)}>
            <Card className={classes.card}>
              <CardContent className={classes.content}>
                  <div style={{ width: '100%'}}>
                    <AutoComplete
                      onChange={this.handleProductChange}
                      selectedSuggestions={selectedProduct}
                      suggestions={suggestions}
                      label="Products"
                      placeholder="Select Product"
                    />
                  </div>
              </CardContent>
            </Card>
            
            <div className={classes.buttonStyle}>
              <Button variant="raised" color="primary" type="submit">Submit</Button>
            </div>
          </Form>
        </Paper>
    );
  };

  render() {
    const { fetching } = this.state;
    
    return (
      <Layout className="App" showMenu menuTitle="Product Selector" toolTip="Having problems? Please review the information you have entered to be sure everything is correct.  If you continue to have problems please contact our Customer Service department at (205) 414-2727." >
        {
          fetching
              ? this.renderLoadingAnimation()
              : this.renderProductForm()
        }
      </Layout>
    );
  }
}

ProductSelector.propTypes = {
  classes: PropTypes.shape().isRequired
};

const mapStateToProps = state => ({
  data: {
    config: state.config.config,
    locations: state.userLocations.userLocations
  }
});

const mapDispatchToProps = dispatch => ({
  actions: {
    getReportTypes: (config) => {
      dispatch(getReportTypes(config));
    },
    getCustomerGroups: (config) => {
      dispatch(getCustomerGroups(config));
    },
    getPersonLocations: (config) => {
      dispatch(search('person-locations', 0, null, config));
    },
    getLocationData: (config) => {
      dispatch(search('locations', 0, null, config, true));
    },
    getCustomers: (config) => {
      dispatch(getCustomers(config));
    },    
    getStateCountry: (config) => {
      dispatch(getStateCountry(config));
    },
    getUsers: (config) => {
      dispatch(search('persons', 0, null, config));
    },
    clearRoutes: () => clearRoutes(dispatch),
    getAvailableProducts: async (locationId, customerId, config, self) => {
      /*
       * if we have a user location in redux store we will retrieve the customerId from there and the customerId
       * parameter will have a valid value. otherwise, we need to make another api call to get current location entity
       * and then get the customerId from the location. We'll then make another API call to get the current customer
       * entity which should have an array of products available to the current customer.
       */
      
      async function getCustomerIdByLocationId(locationId) {
        const locationResult = await dispatch(searchByAttribute('locations', 0, 'locationId', locationId, config, self));
        const { items: locations } = locationResult.value.data;
        
        const location = locations.find(c => c.locationId === locationId);
        
        const { customerId } = location;
        
        return customerId;
      }
      
      async function getProductsByCustomerId(customerId) {
        const customerResult = await dispatch(searchByAttribute('customers', 0, 'customerId', customerId, config, self));
        
        const { items: customers } = customerResult.value.data;
        
        const customer = customers.find(c => c.customerId === customerId);
        
        const { product: products } = customer;
        
        return products;
      }
      
      // if customerId is null/undefined, then API call to get customerId for the current location
      if (!customerId) customerId = getCustomerIdByLocationId(locationId);
      
      // get products for the current customer (based on current user's selected location)
      const customerProducts = await getProductsByCustomerId(customerId);
      if (!customerProducts || !customerProducts.length) {
        self.setState({ fetching: false, availableProducts: self.defaultProducts });
        return;
      }
  
      const availableProducts = customerProducts.map(p => ProductMapReversed[p]);
      localStorage.setItem('showChangeProduct', true);
      if (!availableProducts || !availableProducts.length) {
        self.setState({ fetching: false, availableProducts: self.defaultProducts });
      } else if (availableProducts.length === 1) {
        localStorage.setItem('showChangeProduct', false);
        self.handleSave({ selectedProduct: availableProducts[0] });
        self.setState({ fetching: false, availableProducts });
      } else {
        self.setState({ fetching: false, availableProducts });
      }
    },
  }
});

const ConnectedProductSelector = connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm({ form: 'ProductSelector', validate })(ProductSelector));

export default withStyles(styles, { withTheme: true })(ConnectedProductSelector);


// WEBPACK FOOTER //
// ./src/containers/ProductSelector.js